export const isMastheadLinkList = (e) => e.sys.contentType.sys.id === 'mastheadLinkList';
export const isMastheadLink = (e) => e.sys.contentType.sys.id === 'mastheadLink';
export const isMastheadLinkListItem = (e) => (e ? e.sys.contentType.sys.id === 'mastheadLinkListItem' : false);
export const isLanguageSelectionItem = (e) => (e ? e.sys.contentType.sys.id === 'mastheadLanguageSelection' : false);
//# sourceMappingURL=type-guards.js.map